import React from 'react'
import styles from './End.module.css'
import LiveLink from './LiveLink'

const End = () =>
  <ul className={ styles.list }>
    <li><LiveLink /></li>
  </ul>

export default End
